import { Component } from '@angular/core';
import { RidButton } from '../../../components';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-games-page',
  imports: [RidDemoPage, RidButton],
  templateUrl: './games-page.html',
})
export class GamesPage {}
